<template>
  <div class="calculator dobule-calculator">
    <b-container>
      <div class="inner">
        <div class="calculator-wrapper">
          <div class="chose">
            <h2>Рассчитать стоимость</h2>
            <p>Весь функционал системы доступен по подписке.</p>
            <p>
              Для рассчета стоимости укажите
              <br />продолжительность акции.
            </p>
            <p>
              Система автоматически сформирует коммерческое
              <br />предложение, рассчитает размер ежемесячных
              <br />платежей и стоимость дополнительных услуг, таких
              <br />как авторизация по СМС или обслуживания чат-бота
              <br />на платформе WhatsApp.
            </p>
            <p class="smParagraph">
              Данный рассчет носит исключительно информационный характер
              <br />и ни при каких условиях не является публичной офертой.
            </p>
          </div>
          <div class="chose-right">
            <div class="chose-wrapper">
              <div class="chose">
                <p class="title" v-html="calculator.choseTitle"></p>
                <p class="smParagraph">
                  Чем дольше подписка, тем выгоднее!
                  <br />Тарифный шаг - 1 месяц
                </p>
                <multiselect
                  v-model="duration"
                  track-by="option"
                  label="option"
                  placeholder="1 месяц"
                  :options="durations"
                  :searchable="false"
                  :allow-empty="false"
                  @input="updateFields(duration, registrator)"
                >
                  <template slot="selection" v-if="duration === 1">
                    <span class="multiselect__single">1 месяц</span>
                  </template>
                </multiselect>
              </div>
              <div class="chose">
                <p class="title">Стойка регистрации</p>
                <p class="smParagraph" v-html="calculator.smParagraph"></p>
                <multiselect
                  class="need"
                  v-model="needed"
                  track-by="option"
                  label="option"
                  placeholder="1 человек"
                  :options="neededs"
                  :searchable="false"
                  :allow-empty="false"
                >
                  <template slot="selection" v-if="registrator === 1">
                    <span class="multiselect__single">1 человек</span>
                  </template>
                </multiselect>
              </div>
              <div class="chose" :class="{disable: !needed.count}">
                <p class="title">Регистраторы</p>
                <p class="smParagraph">
                  Укажите количество рабочих мест
                  <br />для регистраторов
                </p>
                <multiselect
                  v-model="registrator"
                  track-by="option"
                  label="option"
                  placeholder="1 человек"
                  :options="registrators"
                  :searchable="false"
                  :allow-empty="false"
                  @input="updateFields(duration, registrator)"
                  :disabled="!needed.count"
                >
                  <template slot="selection" v-if="registrator === 1">
                    <span class="multiselect__single">1 человек</span>
                  </template>
                </multiselect>
              </div>
            </div>
            <ComModal :promise="promise"></ComModal>
          </div>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import ComModal from "@/components/commercial-modal";

export default {
  data() {
    return {
      duration: { option: "1 месяц", count: 1 },
      durations: [
        { option: "1 месяц", count: 1 },
        { option: "2 месяца", count: 2 },
        { option: "3 месяца", count: 3 },
        { option: "4 месяца", count: 4 },
        { option: "5 месяцев", count: 5 },
        { option: "6 месяцев", count: 6 },
        { option: "7 месяцев", count: 7 },
        { option: "8 месяцев", count: 8 },
        { option: "9 месяцев", count: 9 },
        { option: "Более 9 месяцев", count: 10 }
      ],
      needed: { option: "Нет необходимости", count: false },
      neededs: [
        { option: "Нет необходимости", count: false },
        { option: "Необходима", count: true }
      ],
      registrator: { option: "1 человек", count: 1 },
      registrators: [
        { option: "1 человек", count: 1 },
        { option: "2 человека", count: 2 },
        { option: "3 человека", count: 3 },
        { option: "4 человека", count: 4 },
        { option: "5 человек", count: 5 },
        { option: "6 человек", count: 6 },
        { option: "7 человек", count: 7 },
        { option: "8 человек", count: 8 },
        { option: "Более 9 человек", count: 9 }
      ],
      promise: `Мы вышлем вам предложение и иногда будем писать о новостях и новых возможностях программы.`
    };
  },
  props: {
    calculator: Object
  },
  components: {
    Multiselect,
    ComModal
  }
};
</script>